import React, {useContext} from 'react'
import classes from './Modal.module.scss';
import { ModalError } from './ModalError/ModalError';
import {ModalSuccess} from './ModalSuccess/ModalSuccess';
import { LanguageContext } from '../../containers/Language';

export const Modal = (props) => {

    const {dictionary} = useContext(LanguageContext)

    React.useEffect(()=>{
    },[props])
    return (
        <div className={`modal fade modal-footer-bordered p-0 ${classes.modal}`} id={props.id} 
            tabIndex="-1" 
            aria-labelledby={props.id} 
            aria-hidden="true">
            <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <div className={`modal-title ${classes.modalTitle}`} id={props.id} >{props.title}</div>
                    <div className="close" data-bs-dismiss="modal" aria-label="Close">
                        <div className="text">{dictionary.CLOSE}</div>
                        <i className="far fa-times"></i>
                    </div>
                </div>
                
                {props.success ? 
                <div className='modal-body'>
                    <ModalSuccess/>
                </div> :
                props.error ? 
                    <ModalError/> 
                : props.children}
            </div>
            </div>
        </div>
    )
}

